import React, { useMemo, useState } from 'react';
import StepNoItem from './step_no_item';
import { useEffect } from 'react';
import parkService from '../../../services/config/park.service';
import { Button, Image, InputNumber, List, Popover, Space } from 'antd';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import EntranceMotion from '../../../helpers/components/entrance_motion';
import { useDispatch, useSelector } from 'react-redux';
import { set_purchase_detail } from '../../../actions/purchase.action';
import globalHelper from '../../../helpers/functions/global.helper';
import GreyContainer from '../../../helpers/components/grey_container';
import { set_is_add_on, set_available_add_ons  } from '../../../actions/ticket.action';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import AddOnImage from './add_on_image';
import numberHelper from '../../../helpers/functions/number.helper';
import RichTextViewer from '../../../helpers/components/rich_text_viewer';


const PurchaseAddOn = ({ visit_date, ticket_type, park_applicable_add_ons}) => {
    const purchaseRedux = useSelector(state => state.purchase);
    const ticketRedux = useSelector(state => state.ticket);
    const currency = ticketRedux?.park?.currency?.symbol;
    const dispatch = useDispatch();
    const [state, setState] = useState({
        loading : false,
        add_ons : [],

        calculate_loading : false,
    })

    // 2025-07-17, add a usememo for add on section to support melon purchase
    const add_on_sections = useMemo(() => {
        const section_map = new Map();
        for(const item of state?.add_ons){
            const section = item?.add_on?.add_on_section;
            const { add_on_section_id, name, image, sequence,is_insurance } = section ?? {};
            if(!section_map?.has(add_on_section_id)){
                section_map.set(add_on_section_id, {
                    add_on_section_id,
                    name,
                    image,
                    sequence,
                    is_insurance,
                    add_on_setups : [],
                })
            }

            section_map.get(add_on_section_id)?.add_on_setups.push(item);
        }
        return Array?.from(section_map?.values());
    }, [state?.add_ons]);


	const totalTickets = useMemo(() => {
		// Extract all valid ticket_applicable_user_id into matchIds
		const matchIds = park_applicable_add_ons.flatMap(addOn => {
			const users = addOn.add_on_applicable_ticket_users || [];
			// Filter out invalid or undefined objects and map to IDs
			return users
				.filter(u => u && u.ticket_applicable_user_id !== undefined && u.ticket_applicable_user_id !== null)
				.map(u => u.ticket_applicable_user_id);
		});
		// Remove duplicates if needed
		const uniqueMatchIds = [...new Set(matchIds)];

		return (purchaseRedux?.ticket_users || []).reduce((sum, ticket) => {
			if (uniqueMatchIds.includes(ticket?.ticket_applicable_user_id)) {
				return sum + (ticket?.quantity || 0);
			}
			return sum;
		}, 0);
	}, [JSON.stringify(purchaseRedux?.ticket_users)]);

    const checkIsRuleDisabled = (add_on_id) => {
        const add_on = state?.add_ons?.find(x => x?.add_on_id === add_on_id);

        return add_on?.free_add_on_rules?.some(x => x?.is_adjustable === true);
    }

    const calculateAddOnRule = () => {
        let add_add_ons = [];
        const purchased_ticket_users = purchaseRedux?.ticket_users;
        // if there is add on rules, then calculate the quantity for add on
        const add_ons = state?.add_ons?.filter(x => x.free_add_on_rules?.length > 0);
        for(const add_on of add_ons){
            const { add_on_id, add_on_setup_id, free_add_on_rules, } = add_on;

            // loop through rules to get valid tickets
            for(const rule of free_add_on_rules){
                // Filter tickets that match the rule's allowed ticket_applicable_user_id
                const valid_tickets = purchased_ticket_users?.filter(x => rule?.free_add_on_rule_requires?.some(req => req.ticket_applicable_user_id === x?.ticket_applicable_user_id));
                const total_valid_tickets = valid_tickets?.reduce((a, b) => (a + b?.quantity), 0); // Sum up the free add-ons

                const free_add_on_quantity = (
                    Math.floor(total_valid_tickets / rule.max_required_ticket_quantity) +
                    (total_valid_tickets % rule.max_required_ticket_quantity >= rule.min_required_ticket_quantity ? 1 : 0)
                ) * rule.free_add_on_quantity;

                // push to array for add quantity
                add_add_ons.push({
                    add_on_id,
                    quantity : free_add_on_quantity,
                })
            }

            for(const add_add_on of add_add_ons){
                const { add_on_id, quantity } = add_add_on;
                // auto add to quantity
                addQuantity(add_on_id, quantity);
            }
        }
    }

    const fetchAddOn = async () => {
        setState(state => ({...state, loading : true}));
        const { park_applicable_ticket_type_id, } = (ticket_type?.ParkApplicableTicketType);

        // check is special link
        const { special_link } = ticketRedux;
        let get_visit_date = special_link ? null : globalHelper?.parseDate(visit_date);
        const addOnsResponse = await parkService.getAddOn({
            park_applicable_ticket_type_id,
            visit_date : get_visit_date,
            slot_visit_date : globalHelper?.parseDate(visit_date),
            special_link,
        });

        const { add_ons } = addOnsResponse;
        setState(state => ({...state, loading : false, add_ons : add_ons}));
        if(add_ons?.length > 0){
            // set is add on to redux
            dispatch(set_is_add_on(true,));
        }
        dispatch(set_available_add_ons(add_ons));
    }

    const addQuantity = (add_on_id, quantity) => {
        let add_ons = purchaseRedux?.add_ons;
        //check currently have this ticket user or not
        let existing_add_on = add_ons?.find(x => x.add_on_id === add_on_id);
        if(existing_add_on){
            // const calculated_quantity = existing_add_on?.quantity + plus;
            const calculated_quantity = quantity;
            existing_add_on.quantity = calculated_quantity;
            let changed_quantity = add_ons;
            if(calculated_quantity > 0){
                changed_quantity = add_ons?.map((x) => {
                    return (x?.add_on_id === add_on_id) ? existing_add_on : x;
                })
            }else{
                changed_quantity = add_ons?.filter((x) => {
                    return (x?.add_on_id != add_on_id);
                })
            }
            //add quantity
            add_ons = changed_quantity;
        }else{
            //add a new object
            if(quantity > 0){
                const add_on = state?.add_ons?.find(x => x.add_on_id === add_on_id);
                const { add_on : get_add_on, price, add_on_setup_id, minimum_order } = add_on;
                add_ons.push({
                    name : get_add_on?.name,
                    price : price,
                    add_on_id : add_on_id,
                    quantity : quantity,
                    add_on_setup_id : add_on_setup_id,
					add_on_section : get_add_on?.add_on_section,
                    minimum_order : minimum_order,
                })
            }
        }

        dispatch(set_purchase_detail({add_ons}));
    }


      const DescriptionRenderer = ({ description }) => {
        if (!description) return null;

        return (
          <RichTextViewer
          value={description}
          className="ticket-label ticket-title h1 banner-quill"
          style={{
            fontSize: 12,
            color: "var(--secondary-text-color)",
            whiteSpace: "pre-wrap",
            margin: 0,
          }}
          />
        );
      };

    // 2025-04-03, Tent Add On
    // auto add add on if there is add on rules
    useEffect(() => {
        calculateAddOnRule();
    }, [JSON.stringify(purchaseRedux?.ticket_users), state?.add_ons])

    useEffect(() => {
        if (visit_date && ticket_type) {
            fetchAddOn();
        }
    }, [visit_date]); //normal got ticket type, but it will run twice, because parents component has already runned

    useEffect(() => {
        const insuranceAddOns = state?.add_ons?.filter(addon =>
            addon?.add_on_section?.is_insurance === true
        );

        if (totalTickets > 0) {
            insuranceAddOns?.forEach(insurance => {
                const cartItem = purchaseRedux?.add_ons?.find(
                    a => a.add_on_id === insurance.add_on_id
                );

                if (cartItem && cartItem.quantity !== totalTickets) {
                    addQuantity(insurance.add_on_id, totalTickets);
                }
            });
        } else {
            //Remove insurance when tickets = 0
            insuranceAddOns?.forEach(insurance => {
                const cartItem = purchaseRedux?.add_ons?.find(
                    a => a.add_on_id === insurance.add_on_id
                );

                if (cartItem) {
                    addQuantity(insurance.add_on_id, 0);
                }
            });
        }
    }, [totalTickets, state?.add_ons]);

    return (
        <>
            {
                add_on_sections
                ?.sort((a, b) => a?.sequence - b?.sequence)
                ?.map((section, index) => {
                    const { add_on_setups = [], name : add_on_section_name, image : add_on_section_image, add_on_section_id, is_insurance } = section;

                    // ⭐ INSURANCE: Check if this section is insurance
                    const isInsuranceSection = is_insurance === true;

                    return (
						<React.Fragment key={add_on_section_id}>
                            {
                                // (visit_date && state?.add_ons?.length > 0) &&
                                ((visit_date && add_on_setups?.length > 0)) &&
                                (
                                    <>
                                        <EntranceMotion initialY={-100} duration={0.5} delay={0.2}>
                                            <div className='step-4' style={{marginTop:48}}>
                                                <StepNoItem no={4} text={add_on_section_name} image={add_on_section_image} emoji={<>🥪</>} />
                                                <div style={{marginTop:12,}}>
                                                    <List
                                                    size='small'
                                                    dataSource={add_on_setups}
                                                    renderItem={(item, index) => {
                                                        const { name, add_on, price, advance_day, add_on_id, available_slots, free_add_on_rules, minimum_order } = item ?? {};
                                                        const quantity = purchaseRedux?.add_ons?.find(x => x.add_on_id === add_on_id)?.quantity;
                                                        let is_sold_out = false;
                                                        let is_adjustable = true; // default true to set able to adjust
                                                        const is_available = (available_slots == undefined || available_slots > 0);
                                                        if(available_slots != null){
                                                            const remaining_quantity = available_slots - (quantity ?? 0);
                                                            is_sold_out = remaining_quantity <= 0;
                                                        }

                                                        // check is disabled
                                                        if(free_add_on_rules?.length > 0){
                                                            is_adjustable = checkIsRuleDisabled(add_on_id);
                                                        }

                                                        return (
                                                            <List.Item key={add_on_id}>
                                                                <EntranceMotion initialY={-50} duration={1} style={{width : '100%'}}>
                                                                    <div style={{width:'100%'}}>
                                                                        <div style={{display:'flex', flexWrap:'wrap', gap:24}}>
                                                                            <div>
                                                                                <Space align='start' style={{ verticalAlign : 'middle', }}>
                                                                                    <div>
                                                                                        {
                                                                                            add_on?.image &&
                                                                                            (
                                                                                                <>
                                                                                                    <GreyContainer padding={0}>
                                                                                                        <AddOnImage image={add_on?.image} />
                                                                                                    </GreyContainer>
                                                                                                </>
                                                                                            )
                                                                                        }
                                                                                    </div>
                                                                                    <div>
                                                                                        <div>
                                                                                            <span className='ticket-label' style={{fontWeight:500, fontSize:14}}>
                                                                                                {`${add_on?.name}`}
                                                                                            </span>
                                                                                        </div>
                                                                                        <div>
                                                                                          {
                                                                                            minimum_order > 0 &&
                                                                                            (
                                                                                              <div>
                                                                                                 <span style={{fontSize:11, color:'var(--secondary-text-color)'}}>
                                                                                                     {`Min. order: ${minimum_order}`}
                                                                                                 </span>
                                                                                              </div>
                                                                                            )
                                                                                          }

                                                                                            <DescriptionRenderer description={add_on.description} />
                                                                                        </div>
                                                                                        {/* ⭐ INSURANCE: Show insurance pricing info */}
                                                                                        {isInsuranceSection && (
                                                                                            <div style={{marginTop: 4}}>
                                                                                                {totalTickets > 0 ? (
                                                                                                    <span style={{fontSize:11, color:'#888'}}>
                                                                                                        {currency}{numberHelper?.commaNumber(price)} × {totalTickets} ticket{totalTickets > 1 ? 's' : ''}
                                                                                                    </span>
                                                                                                ) : (
                                                                                                    <span style={{fontSize:11, color:'#ff9800'}}>
                                                                                                        ⚠️ Select tickets first
                                                                                                    </span>
                                                                                                )}
                                                                                            </div>
                                                                                        )}
                                                                                    </div>
                                                                                </Space>
                                                                            </div>

                                                                            <div style={{marginLeft:'auto'}}>
                                                                                <div>
                                                                                    {/* ⭐ INSURANCE: Different UI for insurance */}
                                                                                    {isInsuranceSection ? (
                                                                                        // Insurance: Simple Add/Remove button
                                                                                        <Space size={20}>
                                                                                            <div>
                                                                                                <span className='ticket-label' style={{fontWeight:500, fontSize:14}}>
                                                                                                    {`${currency}${numberHelper?.commaNumber(price * totalTickets)}`}
                                                                                                </span>
                                                                                            </div>
                                                                                            <div>
                                                                                                <Button
                                                                                                    type={quantity > 0 ? 'primary' : 'default'}
                                                                                                    onClick={() => {
                                                                                                        if (quantity > 0) {
                                                                                                            addQuantity(add_on_id, 0);
                                                                                                        } else {
                                                                                                            addQuantity(add_on_id, totalTickets);
                                                                                                        }
                                                                                                    }}
                                                                                                    disabled={totalTickets === 0}
                                                                                                    style={{minWidth: 80}}
                                                                                                >
                                                                                                    {quantity > 0 ? 'Remove' : 'Add'}
                                                                                                </Button>
                                                                                            </div>
                                                                                        </Space>
                                                                                    ) : (
                                                                                        // Regular add-ons: Keep original UI
                                                                                        <Space size={20}>
                                                                                            <div>
                                                                                                <span className='ticket-label' style={{fontWeight:500, fontSize:14}}>
                                                                                                    {`${currency}${numberHelper?.commaNumber(price,)}`}
                                                                                                </span>
                                                                                            </div>
                                                                                            <div>
                                                                                                <Button
                                                                                                disabled={(!quantity || quantity <= 0 || !is_adjustable)}
                                                                                                onClick={() => addQuantity(add_on_id, (isNaN(quantity) ? 0 : parseInt(quantity) - 1))}
                                                                                                type='ghost'
                                                                                                style={{background:'#F8F7FA', padding:'4px 10px', opacity : ((!quantity || quantity <= 0 || !is_adjustable) ? '0.5' : '1' )}}
                                                                                                >
                                                                                                    <MinusOutlined />
                                                                                                </Button>
                                                                                            </div>
                                                                                            <div style={{opacity : (is_available ? 1 : 0.5)}}>
                                                                                                <Popover
                                                                                                content={
                                                                                                    <>
                                                                                                        <div style={{padding:8,}}>
                                                                                                            <InputNumber
                                                                                                            precision={0}
                                                                                                            type='number'
                                                                                                            placeholder='Enter ticket quantity'
                                                                                                            value={quantity}
                                                                                                            onChange={(q) => addQuantity(add_on_id, q)}
                                                                                                            style={{width:'100%'}}
                                                                                                            max={available_slots}
                                                                                                            />
                                                                                                        </div>
                                                                                                    </>
                                                                                                }
                                                                                                trigger={ is_available ? ['click'] : []}
                                                                                                placement='bottom'
                                                                                                overlayInnerStyle={{padding : 0,}}
                                                                                                >
                                                                                                    <Button disabled={!is_adjustable}>{quantity ?? 0}</Button>
                                                                                                </Popover>
                                                                                            </div>
                                                                                            <div>
                                                                                                <Button
                                                                                                disabled={(is_sold_out || !is_adjustable)}
                                                                                                onClick={() => addQuantity(add_on_id, ((isNaN(quantity) ? 0 : parseInt(quantity)) + 1))}
                                                                                                type='ghost'
                                                                                                style={{background:'#F8F7FA', padding:'4px 10px',  opacity : ((is_sold_out || !is_adjustable) ? '0.5' : '1' )}}
                                                                                                >
                                                                                                    <PlusOutlined />
                                                                                                </Button>
                                                                                            </div>
                                                                                        </Space>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </EntranceMotion>
                                                            </List.Item>
                                                        )
                                                    }}
                                                    />
                                                </div>
                                            </div>
                                        </EntranceMotion>
                                    </>
                                )
                            }
						</React.Fragment>
                    )
                })
            }
        </>
    );
}

export default PurchaseAddOn;